import React, { useEffect, useState } from "react";
import "../../modules/auth/style/auth.css";

import {
  createSearchParams,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

import { images } from "../../assets/images/index";
import { Title } from "../../components/commonComponents/Title/Title";
import { Terms } from "../../components/commonComponents/Terms & Conditions/Terms";
import Divider from "../../components/commonComponents/divider/Divider";

import { useAspSelector, useAspDispatch } from "../../test/jest-redux-hooks";
import { updateSignUpSteps } from "../../reduxToolkit/authSlice";

import Back from "../../modules/auth/components/AuthBack";
import { Modal } from "antd";
import { invitationAccept } from "../../modules/auth/api/Api";

export const invitation = [
  { id: 1, label: "Yes, join connect", status: "accepted" },
  { id: 2, label: "No, thanks", status: "rejected" },
];

function Index({ children }) {
  let { pathname, params } = useLocation();
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const [queryParams] = useSearchParams();

  const { signUp } = useAspSelector((state) => state.authentication);
  const { currentUser, currentBrand } = useAspSelector((state) => state.app);
  const { resetPasswordEmail } = useAspSelector(
    (state) => state.authentication
  );

  const tokenValidate = queryParams?.get("token");
  const email = localStorage.getItem("email");

  const validationToken2 = queryParams?.get("role");
  const validationName = queryParams?.get("name");
  const validationAccount = queryParams.get("account");

  const isValid = (value) => value !== null && value.trim() !== "";

  if (isValid(validationToken2)) localStorage.setItem("role", validationToken2);
  if (isValid(validationName)) localStorage.setItem("name", validationName);
  if (isValid(validationAccount))
    localStorage.setItem("account", validationAccount);

  const dispatch = useAspDispatch();

  const validRoutes = [
    "/sign-up",
    "/on-boarding",
    "/verify-email",
    "/login",
    "/forgot-password",
    "/reset-password",
  ].includes(pathname);

  const routeValidation =
    pathname === "/forgot-password" ||
    pathname === "/reset-password" ||
    pathname === "/login";
  let titleText, paragraph;

  // navigate({
  //   pathname: '/on-boarding',
  //   search: createSearchParams({
  //     token: validateToken,
  //   }).toString(),
  // });

  useEffect(() => {
    const TOKEN = localStorage.getItem("authToken");
    if (TOKEN) {
      if (!pathname.includes("/sign-up"))
        if (currentUser && !pathname.includes("/verify-email")) {
          if (currentUser?.active_accounts?.length === 0) {
            if (validationToken2 && validationName && validationAccount) {
              setPopoverOpen(true);
            } else {
              navigate("/on-boarding");
            }
            return;
          } else if (
            currentUser &&
            pathname.includes("/login") &&
            email &&
            tokenValidate
          ) {
            return;
          } else if (
            currentUser &&
            currentUser?.active_accounts?.length > 0 &&
            !pathname.includes("/on-boarding")
          ) {
            // if (pathname === "/login") navigate("/user/home");
            // else if (pathname !== "/reset-password") navigate("/Accounts");
            return;
          } else if (
            currentUser &&
            currentUser?.active_accounts?.length > 0 &&
            pathname.includes("/on-boarding")
          ) {
            navigate("/on-boarding");
            return;
          } else {
            navigate("/sign-up");
            // navigate({
            //   pathname: '/sign-up',
            //   search: createSearchParams({
            //     token: tokenValidate,
            //     email: email,
            //   }).toString(),
            // });
            return;
          }
        } else if (pathname.includes("/verify-email")) {
          if (validationToken2 && validationName && validationAccount) {
            setPopoverOpen(true);
          } else {
            navigate("/on-boarding");
          }
          return;
        } else {
          return;
        }
    } else {
      if (pathname.includes("/sign-up")) {
        return;
      } else if (pathname.includes("/on-boarding")) {
        return;
      } else if (pathname.includes("/verify-email")) {
        return;
      } else if (!TOKEN && queryParams?.get("token")) {
        return;
      } else {
        localStorage.clear();
        navigate("/login");
        // navigate({
        //   pathname: '/sign-up',
        //   search: createSearchParams({
        //     token: tokenValidate,
        //   }).toString(),
        // });
        return;
      }
    }
  }, []);

  const goBack = () => {
    dispatch(
      updateSignUpSteps({ ...signUp, step: signUp?.step === 2 ? 1 : 0 })
    );
    dispatch;
  };

  switch (pathname) {
    case "/login":
      titleText = `Welcome Growth`;
      paragraph = "Let us grow your Business together";
      break;
    case "/sign-up":
      titleText = ``;
      paragraph = "";
      break;
    case "/resend":
      titleText = ` Verify your account`;
      paragraph = "";
      break;
    case "/forgot-password":
      titleText = "Forgot Password?";
      paragraph = "No worries, we’ll send you a link to reset your password.";
      break;
    case "/reset-password":
      titleText = "Reset Password";
      paragraph = `Enter a new password for ${resetPasswordEmail}`;
      break;
    case "/stepper":
      titleText =
        "Let’s Ignite Growth with Conversational Relationship Platform";
      paragraph = "";
      break;

    case "/Accounts":
      titleText = "Choose an account you wish to use";
      paragraph =
        "Selecting an account, you will be redirected to it’s primary brand.";
      break;

    default:
      titleText = "";
      paragraph = "";
  }

  const handleClick = (item) => {
    const payLoad = {
      invite_token: TOKEN,
      status: item?.status,
      role_code: validationToken2,
    };

    invitationAccept(payLoad).then((res) => {
      if (res?.status === 200) {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content:
                item?.status === "success"
                  ? "Invitation Success"
                  : "Invitation Rejected",
              status: "Success",
              duration: "",
            },
          ])
        );
        if (item?.status === "accepted") {
          navigate("/Accounts");
        } else if (currentUser?.active_accounts?.length === 0) {
          // navigate("/on-boarding");
        } else if (item?.status === "rejected") {
          navigate("/Accounts");
        }
      } else {
        setPopoverOpen(false);
        navigate("/login");
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: res?.response?.data?.error,
              status: "Error",
              duration: "",
            },
          ])
        );
      }
    });
  };

  const navigationFunc = (navTo) =>
    navTo === "login" ? navigate("/login") : navigate("/sign-up");

  return (
    <div className="h-screen w-screen bg-[var(--background)] flex flex-col md:flex-row">
      <div className="hidden md:!block md:w-[55.5vw] h-full md:rounded-r-[40px] overflow-hidden relative">
        <img
          alt="leftLayout"
          className="w-full h-full object-cover"
          src={images?.leftLayout}
        />
        {/* <span className="rightsText">
          © 2024 Gainwix Inc. All Rights Reserved
        </span> */}
      </div>

      <div className="w-full md:w-[44.5vw] h-full overflow-y-scroll flex flex-col space-between px-[5%]">
        <div className="flex flex-col justify-end items-center py-[7%]">
          <Title content={titleText} paragraph={paragraph} />
        </div>
        <div className="flex flex-col items-center flex-1">
          <Outlet />
          {children}
          {/* {pathname === '/sign-up' && (
            <Divider color={'#d1d3d8'} width={'45%'} />
          )} */}
          {pathname === "/forgot-password" || pathname === "/reset-password" ? (
            <Back onClick={() => navigate("/login")} title={"Back to login"} />
          ) : (
            "/sign-up" &&
            signUp?.step !== 0 && <Back onClick={goBack} title={"Back"} />
          )}
        </div>
        {!pathname.includes("/on-boarding") && (
          <div className="flex flex-col items-center py-[15px]">
            <Terms />
          </div>
        )}
      </div>
      <Modal
        open={popoverOpen}
        closable={false}
        centered={true}
        footer={false}
        wrapClassName={"backdrop-blur-xl"}
        width={"49vw"}
      >
        <div className="w-100 flex-1 items-stretch asp-modal-linear b-radius flex-column align-center pt-16">
          <span className="w-100 text-center font24px-600 text-[var(--textBlack)] mb-20">
            <span className="capitalize">{validationName}</span> has invited you
            to Join "{validationAccount}" account on GainWix.ai
          </span>
          <div className="justify-center flex-column mt-20 mb-20">
            {invitation?.map((item) => {
              return (
                <div
                  className="flex align-center justify-center "
                  key={item?.id}
                  onClick={() => handleClick(item)}
                >
                  <span
                    className={`font16px-500 text-[#4C515B] pointer ${
                      item?.id === 1
                        ? "button-primary b-radius-6 px-7 py-1.5"
                        : "font16px-500 text-[#4C515B] mt-10"
                    }`}
                  >
                    {item?.label}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Index;

//
